import { render, staticRenderFns } from "./PatientIncubatorShow.vue?vue&type=template&id=710e2159&scoped=true"
import script from "./PatientIncubatorShow.vue?vue&type=script&lang=js"
export * from "./PatientIncubatorShow.vue?vue&type=script&lang=js"
import style0 from "./PatientIncubatorShow.vue?vue&type=style&index=0&id=710e2159&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710e2159",
  null
  
)

export default component.exports